import * as React from 'react';
import { useDropzone } from 'react-dropzone';
import './file-upload.scss';
import { ReactComponent as FileIcon } from 'assets/icons/icon_file.svg';
import { ReactComponent as CloseIcon } from 'assets/icons/closecircle.svg';

interface Props {
  isFilesUploaded?: (files: File[]) => void;
}

const FileUpload: React.FunctionComponent<Props> = ({ isFilesUploaded }) => {
  const [uploadedFiles, setUploadedFiles] = React.useState<File[]>([]);

  const onDrop = React.useCallback(
    (acceptedFiles: File[]) => {
      isFilesUploaded && isFilesUploaded([...uploadedFiles, ...acceptedFiles]);
      setUploadedFiles([...uploadedFiles, ...acceptedFiles]);
    },
    [uploadedFiles],
  );

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  const onRemoveFile = (file: File) => () => {
    // const newFiles = [...uploadedFiles];
    // newFiles.splice(newFiles.indexOf(file), 1);
    // setUploadedFiles(newFiles);
    setUploadedFiles([]);
    isFilesUploaded && isFilesUploaded([]);
  };

  const files = uploadedFiles.map((file: any) => (
    <div className="view-uploads" key={file.path}>
      <div className="view-uploads__icon">
        <FileIcon />
      </div>
      <div className="view-uploads__file">{file.path}</div>
      <div className="view-uploads__remove">
        <CloseIcon onClick={onRemoveFile(file)} />
      </div>
    </div>
  ));

  return (
    <>
      {uploadedFiles.length === 0 && (
        <div className="file-upload">
          <div {...getRootProps({ className: 'dropzone' })}>
            <input {...getInputProps()} />
            <button type="button" className="file-upload__button">
              파일선택
            </button>
            <div className="file-upload__drag-file">파일을 드래그해보세요</div>
          </div>
        </div>
      )}
      {uploadedFiles.length > 0 && files}
    </>
  );
};
export default FileUpload;
